/**
 * NetworkStats - Overlay stat chips on the network visualization
 */

import React from 'react';
import { Box, Chip } from '@mui/material';
import {
  People as PeopleIcon,
  Hub as HubIcon,
  Insights as InsightsIcon,
} from '@mui/icons-material';

const STAT_ICONS = {
  totalPeople: <PeopleIcon sx={{ fontSize: 16 }} />,
  totalConnections: <HubIcon sx={{ fontSize: 16 }} />,
  avgStrength: <InsightsIcon sx={{ fontSize: 16 }} />,
};

const STAT_LABELS = {
  totalPeople: 'People',
  totalConnections: 'Connections',
  avgStrength: 'Avg Strength',
};

function NetworkStats({ stats }) {
  if (!stats) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 12,
        right: 12,
        zIndex: 20,
        display: 'flex',
        gap: 0.75,
      }}
    >
      {Object.entries(STAT_LABELS).map(([key, label]) => (
        <Chip
          key={key}
          icon={STAT_ICONS[key]}
          label={`${stats[key] ?? 0} ${label}`}
          size="small"
          variant="outlined"
          sx={{
            bgcolor: 'rgba(255,255,255,0.9)',
            backdropFilter: 'blur(8px)',
            fontSize: '0.7rem',
            height: 28,
          }}
        />
      ))}
    </Box>
  );
}

export default NetworkStats;
